import StopType from "Containers/Stops/StopType";

const stopStateStyles = {
  DEFAULT: {
    [StopType.INSTITUTION]: {
      strokeColor: "#085FE5",
      fillColor: "rgba(8,95,229, 0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/stop_default.svg`,
    },
    [StopType.ACCESSIBILITY]: {
      strokeColor: "#085FE5",
      fillColor: "rgba(8,95,229, 0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/accessible_wheelchair_icon.svg`,
    },
    [StopType.DINING]: {
      strokeColor: "#ff8c00",
      fillColor: "rgba(255, 140, 0, 0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/dining_icon.svg`,
    },
    [StopType.PARKING]: {
      strokeColor: "#3A506B",
      fillColor: "rgba(8, 8, 8, 0.3)",
      marker: `${process.env.REACT_APP_BASE_URL}images/parking_lot_icon.svg`,
    },
    [StopType.RESTROOM]: {
      strokeColor: "#085FE5",
      fillColor: "rgba(8,95,229, 0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/restroom_icon.svg`,
    },
    [StopType.RECREATION]: {
      strokeColor: "#28A745",
      fillColor: "rgba(40, 167, 69, 0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/recreation_icon.svg`,
    },
    [StopType.EMERGENCY]: {
      strokeColor: "#FF0000",
      fillColor: "rgba(200, 0, 0, 0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/emergency_icon.svg`,
    },
  },
  SELECTED: {
    [StopType.INSTITUTION]: {
      strokeColor: "#085FE5",
      fillColor: "rgba(8,95,229, 0.9)",
      marker: `${process.env.REACT_APP_BASE_URL}images/stop_selected.svg`,
    },
    [StopType.ACCESSIBILITY]: {
      strokeColor: "#085FE5",
      fillColor: "rgba(8,95,229, 0.9)",
      marker: `${process.env.REACT_APP_BASE_URL}images/accessible_wheelchair_icon.svg`,
    },
    [StopType.DINING]: {
      strokeColor: "#ff8c00",
      fillColor: "rgba(255, 140, 0, 0.9)",
      marker: `${process.env.REACT_APP_BASE_URL}images/dining_icon.svg`,
    },
    [StopType.PARKING]: {
      strokeColor: "#3A506B",
      fillColor: "rgba(82, 80, 80, 0.9)",
      marker: `${process.env.REACT_APP_BASE_URL}images/parking_lot_icon.svg`,
    },
    [StopType.RESTROOM]: {
      strokeColor: "#085FE5",
      fillColor: "rgba(8,95,229, 0.9)",
      marker: `${process.env.REACT_APP_BASE_URL}images/restroom_icon.svg`,
    },
    [StopType.RECREATION]: {
      strokeColor: "#28A745",
      fillColor: "rgba(40, 167, 69, 0.9)",
      marker: `${process.env.REACT_APP_BASE_URL}images/recreation_icon.svg`,
    },
    [StopType.EMERGENCY]: {
      strokeColor: "#FF0000",
      fillColor: "rgba(200, 0, 0, 0.9)",
      marker: `${process.env.REACT_APP_BASE_URL}images/emergency_icon.svg`,
    },
  },
  VISITED: {
    [StopType.INSTITUTION]: {
      strokeColor: "#6373A4",
      fillColor: "rgba(99,115,164,0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/stop_visited.svg`,
    },
    [StopType.ACCESSIBILITY]: {
      strokeColor: "#6373A4",
      fillColor: "rgba(99,115,164,0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/accessible_wheelchair_icon.svg`,
    },
    [StopType.DINING]: {
      strokeColor: "#b56504",
      fillColor: "rgba(155, 89, 8, 0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/dining_icon.svg`,
    },
    [StopType.PARKING]: {
      strokeColor: "#334357",
      fillColor: "rgba(27, 33, 39, 0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/parking_lot_icon.svg`,
    },
    [StopType.RESTROOM]: {
      strokeColor: "#6373A4",
      fillColor: "rgba(99,115,164,0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/restroom_icon.svg`,
    },
    [StopType.RECREATION]: {
      strokeColor: "#1d4d28",
      fillColor: "rgba(7, 69, 21, 0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/recreation_icon.svg`,
    },
    [StopType.EMERGENCY]: {
      strokeColor: "#9e1818",
      fillColor: "rgba(174, 63, 63, 0.2)",
      marker: `${process.env.REACT_APP_BASE_URL}images/emergency_icon.svg`,
    },
  },
  GMAP: {
    strokeColor: "#45a4fc",
    fillColor: "#ffffff",
    marker: `${process.env.REACT_APP_BASE_URL}images/google_map_marker.svg`,
  },
};

export default stopStateStyles;
